import React from 'react'
import MainContainer from '../../MainContainer'
import s from './menu.module.scss'
import logo from '../../../utilits/img/footerlogo.svg'
import logoClose from '../../../utilits/img/close.svg'
import { navbarLinks } from './../../../consts/navbar';
import { Link } from 'react-router-dom';
import  classNames  from 'classnames';

export default function MenuCom({pathname,show,close}) {
    const handle=()=>{
        close()
    }
    return (
        <div 
        className={classNames(s.menu,show? s.active:s.hide)}
        >
            <MainContainer>
                <div className={s.inner}>
                    <div className={s.header}>
                        <Link to="/" onClick={()=>close()}>
                        <img src={logo} alt="Logo" />
                        </Link>
                          <button onClick={handle}>
                          <img src={logoClose} alt="Close" />
                          </button>
                    </div>
                    <div className={s.items}>
                        {
                            navbarLinks.map(({ path, name }) => (
                                <Link
                                    onClick={()=>close()}
                                    key={path}
                                    to={path}
                                    className={classNames(s.item, path === pathname ? s.active : "")}>
                                    {name}
                                </Link>
                            ))
                        }
                    </div>
                </div>
            </MainContainer>
        </div>
    )
}
